<template>
  <div id="menu" @click.self="handleClose">
    <div class="menu__inner">
      <div class="menu-top">
        <span class="ff-mono tt-u fs-12" @click.self="handleClose"
          >X Close</span
        >
        <AppSocialLinks class="menu__links fs-16"></AppSocialLinks>
      </div>
      <div class="menu-bottom">
        <nav class="menu__nav">
          <ul class="menu__nav__list">
            <li>
              <NuxtLink :to="'/'">
                <AppLink class="menu__link">Home</AppLink>
              </NuxtLink>
            </li>
            <li>
              <NuxtLink :to="'/works'">
                <AppLink class="menu__link">Works</AppLink>
              </NuxtLink>
            </li>
            <li>
              <AppLink
                :class="{ 'is-active': isAboutModalVisible }"
                @click="isAboutModalVisible = !isAboutModalVisible"
                class="menu__link"
                data-custom-link
                >About</AppLink
              >
            </li>
            <li>
              <AppLink
                :class="{ 'is-active': isMailConfirmVisible }"
                @click="isMailConfirmVisible = true; useTrackEvent('contact_click', { link_location: 'mobile_menu' })"
                class="menu__link"
                data-custom-link
                >Contact</AppLink
              >
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({});
const globals = useGlobal();
const isMenuOpen = useMenuOpen();
const isAboutModalVisible = useAboutModal();
const isMailConfirmVisible = useMailConfirmModal();

const { $gsap: gsap, $eventBus } = useNuxtApp();
let tl = gsap.timeline({
  onComplete: () => {
    tl.kill();
  },
});

const handleClose = () => {
  tl.clear();
  tl.to('#menu', { background: 'rgba(0,0,0,0)' });
  tl.to(
    '.menu__inner',
    {
      y: '120%',
      duration: 0.75,
      ease: 'expo.out',
      force3D: true,
      onComplete: () => {
        isMenuOpen.value = false;
      },
    },
    '<'
  );
};

onMounted(() => {
  $eventBus.on('closeMenu', () => {
    handleClose();
  });

  tl.clear();
  tl.to('#menu', { background: 'rgba(0,0,0,0)' });
  tl.to(
    '.menu__inner',
    {
      y: 0,
      duration: 0.75,
      ease: 'smoothNano',
      force3D: true,
    },
    '<'
  );
});

onUnmounted(() => {
  $eventBus.off('closeMenu');
});
</script>

<style lang="scss" scoped>
#menu {
  background: rgba(0, 0, 0, 0);
  height: 100vh;
  position: fixed;
  width: 100vw;
  z-index: layer(menu);
}

.menu__inner {
  backdrop-filter: blur(5rem);
  background: rgba(100, 100, 100, 0.6);
  border-radius: var(--radius);
  bottom: var(--gutter);
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  left: var(--gutter);
  min-height: 50svh;
  padding: var(--offset);
  position: fixed;
  width: calc(100vw - var(--gutter-double));
  transform: translate3D(0, 100%, 0);
  // width: var(--width);
}

.menu-top {
  display: flex;
  justify-content: space-between;
}

.menu__nav__list {
  display: flex;
  flex-direction: column;
  font-size: 4rem;
  gap: 0.1em;

  li {
    display: flex;
    align-items: flex-start;
    gap: var(--gutter-double);
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 0.8rem;
    // margin-top: 0.8rem;
  }
}

.menu__links {
  display: flex;
  flex-direction: column;
  text-align: right;
}

.menu-bottom {
  // color: rgba(255, 255, 255, 0.5);
}
</style>
